import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type Language = 'en' | 'es' | 'pt';

interface LanguageSelectorProps {
  value?: Language;
  onChange?: (value: Language) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' },
    { value: 'pt', label: 'Português' },
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={t('common:selectLanguage', 'Select Language')}
      options={languages}
      style={{ width: 120 }}
    />
  );
};

export default LanguageSelector; 